// a library to wrap and simplify api calls
import apisauce from "apisauce";
import Stripe from './Stripe'

const stripe = new Stripe('pk_live_RyFx40SVvrrOFnXq1AjMDHsE')
// const stripe = new Stripe('pk_test_9sNKRD9piXkifAk6W7Q6uuc0')

// ------
// STEP 1
// ------
//
// Create and configure an apisauce-based api object.
//
const api = apisauce.create({
  baseURL: 'https://api-v3.gowod.app',
  // baseURL: 'http://172.21.0.3:9000',
  // baseURL: 'http://0.0.0.0:9000',
  timeout: 30000
});

// ------
// STEP 2
// ------
//
// Define some functions that call the api.  The goal is to provide
// a thin wrapper of the api layer providing nicer feeling functions
// rather than "get", "post" and friends.
//
// I generally don't like wrapping the output at this level because
// sometimes specific actions need to be take on `403` or `401`, etc.
//
// Since we can't hide from that, we embrace it by getting out of the
// way at this level.
//

const login = (email, password) => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Basic " + btoa(`${email}:${password}`)
  });
  const body = {
    access_token: 'av1RJ69BXnaeVKWXANoDQbuRkPopd7cg'
  };
  return api.post("/auth", body);
}

const getUser = () => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.gwps
  })

  return api.get("/users/me");
}

const updateUser = (newUser) => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.gwps
  })

  return api.put("/users/me", newUser);
}

const getAffiliates = (query) => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.gwps
  })

  return api.get("/affiliates/" + query);
}

const getPremiumInfo = () => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.gwps
  })

  return api.get("/users/info");
}

const cancelPremium = (cancelReason, reasonAddon) => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.gwps
  })

  return api.post("/stripe/appcancel", {cancelReason, reasonAddon});
}

const createStripeToken = (number, expiry, cvc) => {
  let exp_month = null
  let exp_year = null
  if (expiry.indexOf('/') !== -1) {
    const array = expiry.replace(/\s/g,'').split('/')
    exp_month = array[0]
    exp_year = array[1]
  } else {
    exp_month = expiry.substr(0, 2)
    exp_year = expiry.substr(2)
  }
  return stripe.createToken({
    number,
    exp_month,
    exp_year,
    cvc,
 })
}

const updateCreditCard = (stripeToken) => {
  api.setHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + window.localStorage.gwps
  })
  return api.post('/stripe/updatecard', {stripeToken})
}

const subscribeStripe = (stripeEmail, stripeToken, planId, promocode) => {
  api.setHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer av1RJ69BXnaeVKWXANoDQbuRkPopd7cg'
  })
  return api.post('/stripe/subscribe/v2', {stripeEmail, stripeToken, planId, promocode})
}

const verifyPromocode = (promocode) => {
  api.setHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + window.localStorage.gwps
  })
  return api.get(`/promocodes/verification/${promocode}`)
}

const isUserPremium = (userId) => {
  api.setHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer av1RJ69BXnaeVKWXANoDQbuRkPopd7cg'
  })
  return api.get(`/users/${userId}/ispremium`)
}

const getUserPersonalData = () => {
  api.setHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + window.localStorage.gwps
  })
  return api.get(`/users/info/pdata`)
}

const deleteUserAccount = () => {
  api.setHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + window.localStorage.gwps
  })
  return api.delete(`/users`)
}

const logUserFromService = (service, token) => {
  api.setHeaders({
    Authorization: 'Bearer ' + token,
    'Content-Type': 'application/json',
  });
  return api.post(`/auth/${service}`);
};

const changePlan = (newPlanId) => {
  api.setHeaders({
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + window.localStorage.gwps,
  });
  return api.post('/stripe/subscription', { newPlanId });
};

const resetUserPassword = email => {
  api.setHeaders({
    'Content-Type': 'application/json',
    Authorization: 'Bearer av1RJ69BXnaeVKWXANoDQbuRkPopd7cg',
  });
  return api.post('/password/reset', { email });
};

const useCoupon = (code) => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.gwps
  })

  return api.post("/coupons/use", {code});
}

const pauseSubscription = (monthsToPause) => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.gwps
  })

  return api.post("/stripe/pause", {monthsToPause});
}

const unpauseSubscription = () => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.gwps
  })

  return api.post("/stripe/unpause");
}

const reactivateSubscription = () => {
  api.setHeaders({
    "Content-Type": "application/json",
    Authorization: "Bearer " + window.localStorage.gwps
  })

  return api.post("/stripe/reactivate");
}

// ------
// STEP 3
// ------
//
// Return back a collection of functions that we would consider our
// interface.  Most of the time it'll be just the list of all the
// methods in step 2.
//

export default {
  login,
  getUser,
  updateUser,
  getAffiliates,
  getPremiumInfo,
  cancelPremium,
  createStripeToken,
  updateCreditCard,
  subscribeStripe,
  verifyPromocode,
  isUserPremium,
  getUserPersonalData,
  deleteUserAccount,
  logUserFromService,
  changePlan,
  resetUserPassword,
  useCoupon,
  pauseSubscription,
  unpauseSubscription,
  reactivateSubscription
};



// WEBPACK FOOTER //
// ./src/utils/API.js